import React, { Component } from 'react';

export default class CustomerCard extends Component {
    render() {
        const { name, phone, document, email } = this.props;
        return (
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Cliente</h3>
                </div>
                <div className="card-body">
                    <ul className="list-group list-group-flush list my--3">
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Nome
                                    </h5>
                                </div>
                                <div className="col-auto">{name || '-'}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Documento
                                    </h5>
                                </div>
                                <div className="col-auto">{document || '-'}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Telefone
                                    </h5>
                                </div>
                                <div className="col-auto">{phone}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Email
                                    </h5>
                                </div>
                                <div className="col-auto">{email}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Details/CustomerCard.js